// extracted by mini-css-extract-plugin
export var border = "IntroSponsorADogSearch-module--border--247a5";
export var bordersection = "IntroSponsorADogSearch-module--bordersection--34724";
export var buttonwrapper = "IntroSponsorADogSearch-module--buttonwrapper--68b7a";
export var desktop = "IntroSponsorADogSearch-module--desktop--0cb06";
export var herowithimagecontainer = "IntroSponsorADogSearch-module--herowithimagecontainer--4faf1";
export var herowithimagecontainerinner = "IntroSponsorADogSearch-module--herowithimagecontainerinner--587de";
export var herowithimagecontainerouter = "IntroSponsorADogSearch-module--herowithimagecontainerouter--cf6ef";
export var mobile = "IntroSponsorADogSearch-module--mobile--87cf1";
export var perweektext = "IntroSponsorADogSearch-module--perweektext--2c616";
export var textcontainer = "IntroSponsorADogSearch-module--textcontainer--e8241";